import { UPDATE_OPTIONS_PANEL_NAVIGATION_ITEM } from 'FormsUI/actions/OptionsPanelNavigationItems';
import { GENERAL } from 'FormsUI/constants/OptionsPanelNavigationItems';
const INITIAL_STATE = {
  active: GENERAL
};
export function formOptionsPanelNavigationItems(state = INITIAL_STATE, action) {
  switch (action.type) {
    case UPDATE_OPTIONS_PANEL_NAVIGATION_ITEM:
      return {
        active: action.item
      };
    default:
      return state;
  }
}